import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchFilterPipe',
})
export class SearchFilterPipe implements PipeTransform {
  public transform(values: any[], filters: any[]): any[] {
    if (!values || !filters) return values;

    return values.filter(x => filters.findIndex(y => y.id === x.id) === -1);
  }
}
